const tableRows = async (tableKey, apiModel, tableFilters,
  filtersStatus, updateTableRows, updateTableCount) => {
  const index = await apiModel.index(tableFilters, filtersStatus);
  const count = await apiModel.count(filtersStatus);
  updateTableRows({ tableKey, rows: index.data });
  updateTableCount({ tableKey, count: count.data.count });
};

export default { tableRows };
